import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectIconLabel: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-subspaces.project-icon-label-non-final',
		defaultMessage: 'Project icon',
		description: 'Label for the project icon',
	},
	showMoreIconLabel: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-subspaces.show-more-icon-label-non-final',
		defaultMessage: 'Show more icon',
		description: 'Label for the show more icon',
	},
});
